import script from "./OnboardingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingModal.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingModal.vue?vue&type=style&index=0&id=318cf069&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318cf069"]])

export default __exports__